import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { CalendarButtonShapeIcon } from "../../utils/icons";

const BannerWrapper = styled.div`
  width: 100%;
  max-width: 1248px;
  height: 80px;
  border-radius: 12px;
  background: ${({ bgColor }) => bgColor};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border: ${({ color }) => `0.75px solid ${color}`};
  border-radius: 12px;
  margin:20px 0px;
`;

/* Left Decorative Shape */
const LeftShape = styled.div`
  position: absolute;
  left: 0;
  ${'' /* bottom: -60px; */}
  width: 260px;
  ${'' /* height: 200px; */}
  background: ${({ shapeColor }) => shapeColor};
  opacity: 0.5;
  border-radius: 50%;
`;

/* Right Icon Container */
const RightIcon = styled.div`
  position: absolute;
  right: 0px;
  ${'' /* bottom: 8px; */}
  opacity: 0.6;
`;

/* Right Icon Container */
const RightButton = styled.div`
  position: absolute;
  right: 15%;
  ${'' /* bottom: 8px; */}
`;

const Content = styled.div`
  z-index: 2;
  color: ${({ textColor }) => textColor};
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 30px;

`;

const CustomCalendarLinkBanner = ({
  bgColor = "#F1F8F2",
  shapeColor = "#BDDDC2",
  textColor = "#1F2937",
  text = "Connect your calendar to schedule sessions",
  rightIcon,
  rightButton,
  color
}) => {
  useEffect(()=>{},[])
  return (
    <BannerWrapper bgColor={bgColor} color={color}>
      <LeftShape>
        {CalendarButtonShapeIcon(shapeColor)}
      </LeftShape>
      <Content textColor={textColor}>{text}</Content>
      <RightIcon>{rightIcon}</RightIcon>
      <RightButton>{rightButton}</RightButton>

    </BannerWrapper>
  );
};

CustomCalendarLinkBanner.propTypes = {
  bgColor: PropTypes.string,
  shapeColor: PropTypes.string,
  textColor: PropTypes.string,
  text: PropTypes.string,
  rightIcon: PropTypes.node,
  rightButton:PropTypes.node,
  color:PropTypes.string
};

export default CustomCalendarLinkBanner;
